/* src/app/shared/components/two-cp-payment-portal/two-cp-payment-portal.component.scss */
iframe {
  width: 61em;
  height: 57em;
}
.twocp__container {
  display: flex;
  justify-content: center;
}
.e2e-iframe-trusted-src {
  border: 0;
}
/*# sourceMappingURL=two-cp-payment-portal.component.css.map */
